import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-option-card',
  templateUrl: './option-card.component.html',
  styleUrls: ['./option-card.component.scss']
})
export class OptionCardComponent implements OnInit {
  @Input('title') title : string;
  @Input('iconName') iconName : string;

  constructor() { }

  ngOnInit() {
  }

  status: boolean = false;

  click() {
    this.status = !this.status;
  }

}
